import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n); // 全局挂载
let locale = localStorage.getItem("locale");
document.documentElement.setAttribute("lang", locale);
import ar from "./js/ar";
import br from "./js/pt-br";
import de from "./js/de";
import en from "./js/en";
import es from "./js/es";
import fr from "./js/fr";
import it from "./js/it";
import ja from "./js/ja";
import tr from "./js/tr-TR";
export const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "en", // 从localStorage中获取 默认英文
  messages: {
    ar: {
      ...ar,
      ...require("./module/ar"),
    },
    br: {
      ...br,
      ...require("./module/br"),
    },
    de: {
      ...de,
      ...require("./module/de"),
    },
    en: {
      ...en,
      ...require("./module/en"),
    },
    es: {
      ...es,
      ...require("./module/es"),
    },
    fr: {
      ...fr,
      ...require("./module/fr"),
    },
    it: {
      ...it,
      ...require("./module/it"),
    },
    jp: {
      ...ja,
      ...require("./module/jp"),
    },
    tr: {
      ...tr,
      ...require("./module/tr"),
    },
  },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/langurage/i18n.js